export default __webpack_public_path__ + "static/media/Logoimage.61852eed.png";